// export const LOGIN = "LOGIN";
export const loginConstants = {

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    LOGGEDIN_USERDATA: 'LOGGED IN USER DATA',
    LOGGEDIN_USERPERMISSION: 'LOGGED IN USER PERMISSION',
    
    LOGOUT: 'USERS_LOGOUT',

    GETALL_REQUEST: 'USERS_GETALL_REQUEST',
    GETALL_SUCCESS: 'USERS_GETALL_SUCCESS',
    GETALL_FAILURE: 'USERS_GETALL_FAILURE',
  
};

export const selectScheduleConstants ={
    GET_SELECT_SCHEDULE_DATA : 'SELECT SCHEDULE DATA',
};